import { FC } from "react";

import {
  VideoPlayer as VideoPlayerUI,
  VideoPlayerProps as VideoPlayerUIProps,
} from "@jti/ui/components/VideoPlayer";

import { videoPlayerInputs } from "./VideoPlayer.builder";

export type VideoPlayerProps = BuilderComponentProps<typeof videoPlayerInputs>;

export const VideoPlayer: FC<VideoPlayerProps> = (props) => {
  const commonProps: Partial<VideoPlayerUIProps> = {
    poster: props.posterImage,
    description: props.description,
    playLabel: props.playLabel,
    replayLabel: props.replayLabel,
    soundOnLabel: props.soundOnLabel,
    muteLabel: props.muteLabel,
    showFullscreenLabel: props.showFullScreenLabel,
    showDuration: props.duration,
    showFullscreen: props.showFullscreen,
    showControls: props.showControls,
    preventMainPlayButtonClick: props.preventMainPlayButtonClick,
    preload: props.preload,
    contentSize: props.contentSize,
    themeClass: props.controlColor === "light" ? "page--dark" : "light-theme",
  };

  if (props.videoType === "youtube") {
    const uiProps: VideoPlayerUIProps = {
      ...commonProps,
      desktopSrc: "",
      externalLinkVideo: props?.youtubeConfiguration?.externalLinkVideo,
      hostedExternally: true,
    };

    return <VideoPlayerUI {...uiProps} />;
  }

  const uiProps: VideoPlayerUIProps = {
    ...commonProps,
    loop: props.hostedVideoConfiguration?.loop,
    autoPlay: props.hostedVideoConfiguration?.autoPlay,
    desktopSrc: props.hostedVideoConfiguration.desktopSrc,
    tabletSrc: props.hostedVideoConfiguration?.tabletSrc,
    mobileSrc: props.hostedVideoConfiguration?.mobileSrc,
    alt: props.posterAlt,
  };

  return <VideoPlayerUI {...uiProps} />;
};
